module.exports = __webpack_public_path__ + "img/SozioAnima_01_FM.2857585c.jpg";